import React from 'react';
import { FeedingTimeTooltip } from '../DetailTooltips';

/**
 * Renderiza el bloque RangeSummary de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function RangeSummary({
  v
}) {
  return v.showRng ? React.createElement(React.Fragment, null, React.createElement("section", {
    "onMouseLeave": v.rgLeave,
    style: {
      "position": "absolute",
      "bottom": "0.740741vh",
      "left": "1.041667vw",
      "right": "1.041667vw",
      "zIndex": "80",
      "background": "linear-gradient(180deg,rgba(16,32,54,0.97),rgba(8,18,34,0.97))",
      "boxShadow": "0 1.666667vh 3.703704vh rgba(0,0,0,0.55)",
      "border": "0.092593vh solid rgba(232,80,20,0.35)",
      "borderRadius": "0.925926vh",
      "padding": "0.925926vh 1.296296vh 1.111111vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.740741vh"
    }
  }, v.text("\n    "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "1.111111vh"
    }
  }, React.createElement("h2", {
    style: {
      "margin": "0",
      "fontSize": "1.574074vh",
      "fontWeight": "600",
      "whiteSpace": "nowrap"
    }
  }, v.text("Rangos entre jaulas")), React.createElement("span", {
    style: {
      "fontSize": "1.296296vh",
      "color": "#8793a6",
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "ellipsis",
      "minWidth": "0"
    }
  }, v.text(v.rgPer + " · acumulado del período")), React.createElement("button", {
    "onClick": v.rgClose,
    "title": "Ocultar rangos",
    style: {
      "marginLeft": "auto",
      "width": "1.354167vw",
      "height": "2.407407vh",
      "border": "0",
      "background": "transparent",
      "color": "#8793a6",
      "cursor": "pointer",
      "fontSize": "1.851852vh",
      "borderRadius": "0.462963vh",
      "flex": "none"
    },
    className: "scapp-full-hover"
  }, v.text("×"))), v.text("\n    "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "minmax(0,1.25fr) repeat(3,minmax(0,1fr))",
      "gap": "0.925926vh"
    }
  }, v.text("\n      "), React.createElement("div", {
    style: {
      "background": "rgba(6,14,28,0.55)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.740741vh",
      "padding": "0.925926vh 1.111111vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.555556vh",
      "minWidth": "0"
    }
  }, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "alignItems": "baseline",
      "flexWrap": "wrap",
      "gap": "0.740741vh"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.388889vh",
      "fontWeight": "600",
      "whiteSpace": "nowrap"
    }
  }, v.text("Horario de alimentación")), React.createElement(FeedingTimeTooltip, {
    content: v.rgHHTip
  }, React.createElement("span", {
    style: {
      "font": "1.203704vh 'IBM Plex Mono',monospace",
      "color": "#b8c1ce",
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "ellipsis"
    }
  }, v.text(v.rgHH)))), v.text("\n        "), React.createElement("div", {
    style: {
      "position": "relative",
      "height": "6.111111vh",
      "overflow": "hidden",
      "display": "flex",
      "flexDirection": "column"
    }
  }, v.text("\n          "), (v.rgT || []).map((x, index1) => React.createElement(React.Fragment, {
    key: index1
  }, React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "0",
      "bottom": "0",
      "left": x.l,
      "borderLeft": "0.052083vw dashed rgba(135,147,166,0.15)",
      "pointerEvents": "none"
    }
  }, null))), v.text("\n          "), (v.rgHrs || []).map((h, index2) => React.createElement(React.Fragment, {
    key: index2
  }, React.createElement("div", {
    "onMouseEnter": h.enter,
    "onClick": h.click,
    style: {
      "position": "relative",
      "flex": "1",
      "minHeight": "0",
      "cursor": "pointer"
    }
  }, React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "50%",
      "height": "0.277778vh",
      "marginTop": "-0.138889vh",
      "left": h.l,
      "width": h.w,
      "background": h.bg,
      "opacity": h.op,
      "borderRadius": "0.185185vh",
      "borderLeft": "0.15625vw solid " + h.sL,
      "borderRight": "0.15625vw solid " + h.eL,
      "boxSizing": "border-box"
    }
  }, null)))), v.text("\n        ")), v.text("\n        "), React.createElement("div", {
    style: {
      "position": "relative",
      "height": "1.111111vh"
    }
  }, (v.rgT || []).map((x, index3) => React.createElement(React.Fragment, {
    key: index3
  }, React.createElement("span", {
    style: {
      "position": "absolute",
      "left": x.l,
      "transform": x.tx,
      "font": "1.111111vh 'IBM Plex Mono',monospace",
      "color": "#5a667a"
    }
  }, v.text(x.t))))), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "flexWrap": "wrap",
      "gap": "0.740741vh",
      "fontSize": "1.203704vh",
      "color": "#8793a6"
    }
  }, React.createElement("span", {
    style: {
      "overflowWrap": "anywhere",
      "minWidth": "0"
    }
  }, v.text("Inicio más temprano "), React.createElement(FeedingTimeTooltip, {
    content: v.rgE0Tip,
    align: "left"
  }, React.createElement("b", {
    style: {
      "font": "600 1.203704vh 'IBM Plex Mono',monospace",
      "color": "oklch(0.8 0.14 50)"
    }
  }, v.text(v.rgE0)))), React.createElement("span", {
    style: {
      "overflowWrap": "anywhere",
      "minWidth": "0"
    }
  }, v.text("Fin más tardío "), React.createElement(FeedingTimeTooltip, {
    content: v.rgE1Tip,
    align: "right"
  }, React.createElement("b", {
    style: {
      "font": "600 1.203704vh 'IBM Plex Mono',monospace",
      "color": "oklch(0.8 0.14 50)"
    }
  }, v.text(v.rgE1))))), v.text("\n      ")), v.text("\n      "), (v.rgCards || []).map((c, index4) => React.createElement(React.Fragment, {
    key: index4
  }, React.createElement("div", {
    style: {
      "background": "rgba(6,14,28,0.55)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.740741vh",
      "padding": "0.925926vh 1.111111vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.555556vh",
      "minWidth": "0"
    }
  }, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "alignItems": "baseline",
      "gap": "0.740741vh"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.388889vh",
      "fontWeight": "600",
      "whiteSpace": "nowrap"
    }
  }, v.text(c.l)), React.createElement("span", {
    style: {
      "font": "1.203704vh 'IBM Plex Mono',monospace",
      "color": "#b8c1ce",
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "ellipsis"
    }
  }, v.text(c.selT))), v.text("\n        "), React.createElement("div", {
    style: {
      "position": "relative",
      "height": "3.703704vh",
      "marginTop": "0.555556vh"
    }
  }, v.text("\n          "), React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "4%",
      "right": "4%",
      "top": "50%",
      "height": "0.37037vh",
      "marginTop": "-0.185185vh",
      "borderRadius": "0.185185vh",
      "background": "linear-gradient(90deg,rgba(46,179,238,0.15),rgba(46,179,238,0.4),rgba(46,179,238,0.15))"
    }
  }, null), v.text("\n          "), React.createElement("div", {
    style: {
      "position": "absolute",
      "left": c.med,
      "top": "0.740741vh",
      "bottom": "0.740741vh",
      "width": "0.104167vw",
      "marginLeft": "-0.052083vw",
      "background": "#e4e9f0",
      "opacity": "0.6"
    }
  }, null), v.text("\n          "), (c.dots || []).map((d, index5) => React.createElement(React.Fragment, {
    key: index5
  }, React.createElement("div", {
    "onMouseEnter": d.enter,
    "onClick": d.click,
    style: {
      "position": "absolute",
      "left": d.left,
      "top": "50%",
      "width": d.sz,
      "height": d.sz,
      "transform": "translate(-50%,-50%)",
      "borderRadius": "50%",
      "background": d.bg,
      "border": d.bd,
      "boxSizing": "border-box",
      "cursor": "pointer",
      "zIndex": d.z
    }
  }, null))), v.text("\n          "), c.tipOn ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "position": "absolute",
      "left": c.tipL,
      "top": "-1.296296vh",
      "transform": "translateX(-50%)",
      "background": "rgba(6,14,28,0.96)",
      "border": "0.092593vh solid rgba(46,179,238,0.35)",
      "borderRadius": "0.37037vh",
      "padding": "0.092593vh 0.555556vh",
      "font": "600 1.203704vh 'IBM Plex Mono',monospace",
      "maxWidth": "26.041667vw",
      "whiteSpace": "normal",
      "textAlign": "center",
      "pointerEvents": "none",
      "zIndex": "5"
    }
  }, v.text(c.tipT))) : null, v.text("\n        ")), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "gap": "0.740741vh",
      "font": "1.203704vh 'IBM Plex Mono',monospace"
    }
  }, React.createElement("span", {
    style: {
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "color": "#8793a6"
    }
  }, v.text("mín")), v.text(" "), React.createElement("b", {
    style: {
      "color": "#e4e9f0"
    }
  }, v.text(c.minV)), v.text(" "), React.createElement("span", {
    style: {
      "color": "#8793a6"
    }
  }, v.text(c.minC))), React.createElement("span", {
    style: {
      "color": "#5a667a",
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "ellipsis",
      "minWidth": "0"
    }
  }, v.text(c.medV)), React.createElement("span", {
    style: {
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "color": "#8793a6"
    }
  }, v.text("máx")), v.text(" "), React.createElement("b", {
    style: {
      "color": "#e4e9f0"
    }
  }, v.text(c.maxV)), v.text(" "), React.createElement("span", {
    style: {
      "color": "#8793a6"
    }
  }, v.text(c.maxC)))), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "gap": "0.740741vh",
      "fontSize": "1.203704vh"
    }
  }, React.createElement("span", {
    style: {
      "color": "#8793a6",
      "whiteSpace": "nowrap"
    }
  }, v.text(c.disp))), v.text("\n        "), c.hasNd ? React.createElement(React.Fragment, null, React.createElement("span", {
    style: {
      "fontSize": "1.203704vh",
      "color": "#5a667a"
    }
  }, v.text(c.nd))) : null, v.text("\n      ")))), v.text("\n    ")), v.text("\n  "))) : null;
}
